import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/web/routes/-legal/LegalPage";
import privacyHtml from "@/web/routes/-legal/privacy-policy.md?html";
import { appUrl } from "@/web/lib/siteUrls";

const DESCRIPTION =
  "How With Studios, Inc. collects, uses, and protects your personal information.";

export const Route = createFileRoute("/privacy")({
  ssr: true,
  head: () => ({
    meta: [
      { title: "Privacy Policy — WITH.CO" },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: "Privacy Policy — WITH.CO" },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: appUrl("/privacy") },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => <LegalPage title="Privacy Policy" html={privacyHtml} />,
});
